export default __webpack_public_path__ + "static/media/craon36.d5d24d67.jpg";